import { HttpParams } from "@angular/common/http";
import { Kanban } from "./kanban.model";

export class KanbanFiltersHelper {
  static mapFiltersToQueryParam(filters: Kanban.Card.Filters.Filter[]): HttpParams {
    let params = new HttpParams()

    for (const filter of filters) {
      const rawKey = filter.fixed ? filter.id : `field.${filter.id}`
      const key = rawKey === 'tagId' ? 'tags' : rawKey
      const value = `${filter.operator}.${filter.value}`
      params = params.append(key, value)
    }

    return params
  }
}
